const allowedPostcodeLookupTiers = ['trial', 'business', 'enterprise']

const getSubscriptionCandidates = (subscription) => {
  if (!subscription) {
    return []
  }

  if (Array.isArray(subscription)) {
    return subscription.filter(item => item && typeof item === 'object')
  }

  return [subscription]
}

export const SubscriptionHelper = {
  getSubscriptionTierName (subscription) {
    if (!subscription) {
      return ''
    }

    const candidateValues = []

    if (subscription.subscriptionType && typeof subscription.subscriptionType === 'object') {
      candidateValues.push(subscription.subscriptionType.name)
      candidateValues.push(subscription.subscriptionType.title)
    }

    candidateValues.push(
      subscription.tier,
      subscription.subscriptionTier,
      subscription.plan,
      subscription.subscriptionType,
      subscription.type
    )

    const tierName = candidateValues.find(value => typeof value === 'string' && value.trim())
    return tierName ? tierName.trim().toLowerCase() : ''
  },
  canUsePostcodeLookup (subscription) {
    const candidates = getSubscriptionCandidates(subscription)

    for (const candidate of candidates) {
      const tierName = this.getSubscriptionTierName(candidate)
      if (tierName === 'core') {
        return false
      }

      const featureValue = candidate?.feature?.postcodeLookupAllowed ??
        candidate?.feature?.postcodeAllowed ??
        candidate?.postcodeLookupAllowed ??
        candidate?.postcodeAllowed

      if (typeof featureValue === 'boolean') {
        return featureValue
      }

      if (typeof featureValue === 'string') {
        return ['true', '1', 'yes', 'y'].includes(featureValue.toLowerCase())
      }

      if (allowedPostcodeLookupTiers.includes(tierName)) {
        return true
      }
    }

    return false
  }
}
